import { render, staticRenderFns } from "./rmu-icon.vue?vue&type=template&id=7c088f3e"
import script from "./rmu-icon.vue?vue&type=script&lang=js"
export * from "./rmu-icon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports